<template>
  <div class="min-h-screen relative bg-black text-white grid md:grid-cols-2">
    <!-- Lado esquerdo com imagem (desktop) -->
    <div class="hidden md:flex items-center justify-center relative">
      <img
        src="/cashbroker-bg.png"
        alt="Cash Broker Background"
        class="absolute inset-0 w-full h-full object-cover"
      />
      <div class="z-10 text-center">
        <h1 class="text-8xl font-bold text-white drop-shadow-lg">Cash</h1>
        <h2
          class="text-4xl font-semibold text-orange-500 tracking-widest mt-2 drop-shadow-lg"
        >
          BROKER
        </h2>
      </div>
    </div>

    <!-- Fundo com imagem no mobile -->
    <div class="md:hidden absolute inset-0 -z-10">
      <img
        src="/cashbroker-bg.png"
        alt="Cash Broker Background Mobile"
        class="w-full h-full object-cover opacity-20"
      />
      <div class="absolute inset-0 bg-black bg-opacity-80"></div>
    </div>

    <!-- Formulário ocupa o grid inteiro do lado direito -->
    <div
      class="flex items-center justify-center p-6 overflow-auto bg-[#0f0f0f] relative z-10"
    >
      <div class="w-full max-w-4xl">
        <!-- Logo -->
        <div class="flex items-center justify-center gap-4 mb-6">
          <img src="/image/logo.png" alt="Logo" class="h-16 w-auto" />
          <div class="leading-tight">
            <h1 class="text-white text-3xl font-bold">Cash</h1>
            <h2 class="text-orange-500 text-xl font-semibold tracking-widest">
              BROKER
            </h2>
          </div>
        </div>

        <h2 class="text-white text-xl font-semibold text-center mb-6">
          Crie sua conta
        </h2>

        <!-- Formulário com grid -->
        <form
          class="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-4"
          @submit.prevent="handleRegister"
        >
          <div class="col-span-2">
            <label class="text-sm text-gray-300 block mb-1"
              >Nome completo</label
            >
            <input
              v-model="form.fullName"
              type="text"
              class="w-full p-3 rounded-md bg-black/60 border border-gray-700 text-white placeholder-gray-500"
              required
            />
          </div>

          <div>
            <label class="text-sm text-gray-300 block mb-1">CPF</label>
            <input
              v-model="form.cpf"
              type="text"
              class="w-full p-3 rounded-md bg-black/60 border border-gray-700 text-white placeholder-gray-500"
              required
            />
          </div>

          <div>
            <label class="text-sm text-gray-300 block mb-1"
              >Data de nascimento</label
            >
            <input
              v-model="form.birthday"
              type="date"
              class="w-full p-3 rounded-md bg-black/60 border border-gray-700 text-white"
              required
            />
          </div>

          <div class="col-span-2">
            <label class="text-sm text-gray-300 block mb-1"
              >Telefone (com DDD e país)</label
            >
            <input
              v-model="form.phone"
              type="tel"
              class="w-full p-3 rounded-md bg-black/60 border border-gray-700 text-white placeholder-gray-500"
              required
            />
          </div>

          <div class="col-span-2">
            <label class="text-sm text-gray-300 block mb-1">E-mail</label>
            <input
              v-model="form.email"
              type="email"
              class="w-full p-3 rounded-md bg-black/60 border border-gray-700 text-white placeholder-gray-500"
              required
            />
          </div>

          <div>
            <label class="text-sm text-gray-300 block mb-1">Senha</label>
            <input
              v-model="form.password"
              type="password"
              class="w-full p-3 rounded-md bg-black/60 border border-gray-700 text-white placeholder-gray-500"
              required
            />
          </div>

          <div>
            <label class="text-sm text-gray-300 block mb-1"
              >Confirmação de senha</label
            >
            <input
              v-model="form.passwordConfirmation"
              type="password"
              class="w-full p-3 rounded-md bg-black/60 border border-gray-700 text-white placeholder-gray-500"
              required
            />
          </div>

          <div class="col-span-2">
            <button
              type="submit"
              class="w-full py-3 mt-2 rounded-md bg-gradient-to-r from-orange-600 to-red-600 hover:opacity-90 transition font-semibold"
            >
              Criar Conta
            </button>

            <p v-if="auth.error" class="text-red-400 text-sm text-center mt-2">
              {{ auth.error }}
            </p>
          </div>
        </form>

        <!-- Link para login -->
        <div class="text-center mt-6">
          <RouterLink
            to="/auth/login"
            class="text-sm text-gray-400 hover:text-orange-400 transition"
          >
            Já tem uma conta? <span class="underline">Entrar</span>
          </RouterLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useAuthStore } from "@/stores/auth";
import { create } from "@bufbuild/protobuf";
import { RegisterRequestSchema } from "@/gen/api/v1/auth_pb";

const route = useRoute();
const router = useRouter();
const auth = useAuthStore();

const form = ref({
  fullName: "",
  cpf: "",
  birthday: "",
  phone: "",
  email: "",
  password: "",
  passwordConfirmation: "",
});

onMounted(() => {
  auth.error = "";
});

async function handleRegister() {
  if (form.value.password !== form.value.passwordConfirmation) {
    auth.error = "As senhas não coincidem.";
    return;
  }

  const refCode = route.query.ref as string | undefined;

  const payload = {
    ...form.value,
    sponsorCode: refCode || undefined,
  };

  await auth.register(create(RegisterRequestSchema, payload));

  if (!auth.error) {
    router.push("/auth/login");
  }
}
</script>
